import { render } from "./BaseSidebar.vue?vue&type=template&id=28244f33&scoped=true"
import script from "./BaseSidebar.vue?vue&type=script&lang=js"
export * from "./BaseSidebar.vue?vue&type=script&lang=js"

import "./BaseSidebar.vue?vue&type=style&index=0&id=28244f33&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28244f33"]])

export default __exports__